export default {
    'invoice-no': 'Invoice No.',
    new: 'New',
    delete: 'Delete',
    account: 'Account',
    'invoice-date': 'Invoice date',
    warehouse: 'Warehouse',
    document: 'Ref. Doc.',
    'net-invoice': 'Grand Amount',
    edit: 'Edit',
    save: 'Save',
    not: 'Non',
    posted: 'Posted',
    'add-invoice': 'Add invoice',
    notes: 'Notes',
    'account-trade-config': 'Purchases Account',
    create: 'Create',
    cancel: 'Cancel',
    "choose-serial-number-alert": "Serial Number Alert",
    "choose-serial-number-alert-content": "You have added a serial number that has already been used for another material. Are you sure you want to use it?"
    ,
    "add-serial-number": "Add serial number",
    "serial-number": "Serial number",
    "serial-numbers": "Serial numbers",
    'delete-entry': 'Delete Item',
    'are-you-sure-you-want-to-delete-the-entry': 'Do you want to delete this item?',
    
    'delete-invoice': 'Delete invoice',
    'are-you-sure-you-want-to-delete-the-invoice-that-will-delete-the-associated-bond': 'Do you want to  delete this invoice? the related bond will also be deleted?',
    discount: 'Discount',
    total: 'Total',

    headers: {
        no: 'Serial',
        warehouse: 'Warehouse',
        material: 'Item',
        quantity: 'Quantity',
        count: 'Count',
        price: 'Price',
        'total-amount': 'Net amount',
        'notes': 'Notes',
        'delivery-status': 'Material status'
    },

    'context-menu': {
        edit: 'Edit',
        delete: 'Delete'
    },
    payments: 'Payments',
    'total-payments': 'Total payments',
    'alert-message': 'Alert message',
    'confirm-message': 'The total receipts have become greater than the total. Do you want to continue?',
    'total-expenses': 'Total expenses',
    'expenses': 'Expenses',

    'confirm-dialog-title': 'something in the title',
    'confirm-dialog-content': 'something in the content',
    'confirm-dialog-actions': {
        confirm: 'Confirm',
        cancel: 'Cancel'
    },
    'export-payment-bond': 'Export payment bond',
}